import { useState, useEffect } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Box,
  Typography
} from "@mui/material";
import {
  Logout,
  Login,
  Edit
} from "@mui/icons-material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PersonOutline from "@mui/icons-material/PersonOutline";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/AuthContext";
import { debugLog } from "../services/debugLog";

const UserMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { t } = useTranslation("navbar");
  const { isAuthenticated, logout, token, user } = useAuth();
  const userName = user?.profile_name || user?.first_name || "User";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogin = () => {
    handleClose();
    navigate("/login");
  };

  const handleLogout = () => {
    logout();
    handleClose();
    navigate("/");
  };

  const handleProfile = () => {
    handleClose();
    navigate("/profile");
  };

  useEffect(() => {
      debugLog("🔍 is Authenticated", isAuthenticated, "token", token);
    }, [isAuthenticated, token]);

  useEffect(() => {
    const handleAuthChange = () => {
      setRefresh((prev) => !prev); // fuerza re-render sin efectos colaterales
     // Forzar re-render
     //  setAnchorEl(null); // o cualquier cambio de estado trivial
    };

    window.addEventListener("authChanged", handleAuthChange);
    return () => window.removeEventListener("authChanged", handleAuthChange);
  }, []);

  return (
    <>
      <IconButton
          size="large"
          edge="end"
          color="inherit"
          onClick={handleClick}
      >
            {isAuthenticated ? <AccountCircle /> : <PersonOutline />}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            color: "#000000",
            "& .MuiMenuItem-root": {
              fontWeight: 500,
              color: "#333" // 👈 igual que el idioma no seleccionado
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "#f0f0f0",
            },
          },
        }}
      >
 {!isAuthenticated
  ? [
      <MenuItem onClick={handleLogin} key="login">
        <ListItemIcon>
          <Login fontSize="small" />
        </ListItemIcon>
        {t("login")}
      </MenuItem>,
      <Divider sx={{ my: 1 }} key="divider1" />,
      <MenuItem
        onClick={() => {
          handleClose();
          navigate("/signup");
        }}
        key="signup"
      >
        <ListItemIcon>
          <PersonOutline fontSize="small" />
        </ListItemIcon>
        {t("signup")}
      </MenuItem>
    ]
  : [
      <MenuItem disabled key="hello">
        <Typography variant="subtitle1" fontWeight="bold">
          {t("user_hello")} {userName}!
        </Typography>
      </MenuItem>,
      <Divider sx={{ my: 1 }} key="divider2" />,
      <MenuItem onClick={handleProfile} key="profile">
        <ListItemIcon>
          <Edit fontSize="small" />
        </ListItemIcon>
        {t("edit_profile")}
      </MenuItem>,
      <Divider sx={{ my: 1 }} key="divider3" />,
      <MenuItem onClick={handleLogout} key="logout">
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        {t("logout")}
      </MenuItem>,
      ...(user?.id && [1, 2, 3].includes(user.id)
        ? [
            <Divider sx={{ my: 1 }} key="divider4" />,
            <MenuItem
              onClick={() => {
                handleClose();
                navigate("/admin");
              }}
              key="admin"
            >
              <ListItemIcon>
                <DashboardIcon fontSize="small" />
              </ListItemIcon>
              Admin
            </MenuItem>
          ]
        : [])
    ]}

      </Menu>
    </>
  );
};

export default UserMenu;
